import {logger} from 'utils';

class PartnerStackService {
    init(appKey: string): void {
        const {growsumo, growsumoInit} = window as any;
        if (!growsumo) {
            this.logScriptNotLoaded();
            return;
        }

        try {
            growsumo._initialize(appKey);
            growsumoInit?.();
            logger.debug({category: logger.category.PartnerStack, message: 'Init completed'});
        } catch (error) {
            logger.error({category: logger.category.PartnerStack, message: 'Init failed'}, error);
        }
    }

    setUserInfo({name, email, customerKey}): void {
        const {growsumo} = window as any;
        if (!growsumo) {
            this.logScriptNotLoaded();
            return;
        }

        growsumo.data.name = name;
        growsumo.data.email = email;
        growsumo.data.customer_key = customerKey;
    }

    signup(): void {
        const {growsumo} = window as any;
        if (!growsumo) {
            this.logScriptNotLoaded();
            return;
        }

        growsumo.createSignup((...params) => {
            logger.debug({category: logger.category.PartnerStack, message: 'Signup completed'}, params);
        });
    }

    private logScriptNotLoaded() {
        logger.error({category: logger.category.PartnerStack, message: 'Init failed. Please check the script is loaded'});
    }
}

export const partnerStackService = new PartnerStackService();